import { render, staticRenderFns } from "./ErrorDadosIncompletos.vue?vue&type=template&id=515cb6f0&scoped=true&"
import script from "./ErrorDadosIncompletos.vue?vue&type=script&lang=js&"
export * from "./ErrorDadosIncompletos.vue?vue&type=script&lang=js&"
import style0 from "./ErrorDadosIncompletos.vue?vue&type=style&index=0&id=515cb6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cb6f0",
  null
  
)

export default component.exports